var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"pb-0":"","pt-2":""}},[_c('page-title',{attrs:{"title":"訂單紀錄"}})],1),_c('liff-list',{attrs:{"listKey":_vm.listKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }